import type { TagProps } from "@luce/ui";

import { GiftCardOccasionType, GiftCardStatusEnum } from "../__generated__/graphql";
import birthday from "./assets/heroes/birthday.png";
import christmas from "./assets/heroes/christmas.png";
import cny from "./assets/heroes/cny.png";
import congrats from "./assets/heroes/congrats.png";
import deepavali from "./assets/heroes/deepavali.png";
import eidMubarak from "./assets/heroes/eid-mubarak.png";
import fathersDay from "./assets/heroes/fathers-day.png";
import getWell from "./assets/heroes/get-well.png";
import giftForYou from "./assets/heroes/gift-for-you.png";
import halloween from "./assets/heroes/halloween.png";
import mothersDay from "./assets/heroes/mothers-day.png";
import newBorn from "./assets/heroes/new-born.png";
import newYear from "./assets/heroes/new-year.png";
import thankYou from "./assets/heroes/thank-you.png";
import valentines from "./assets/heroes/valentines.png";
import wedding from "./assets/heroes/wedding.png";

/** `GENERAL` covers both the "Gift for You" and "Special" occasions; it renders the "Gift for You" hero. */
const HERO_BY_OCCASION: Record<GiftCardOccasionType, string | number> = {
  [GiftCardOccasionType.General]: giftForYou,
  [GiftCardOccasionType.Birthday]: birthday,
  [GiftCardOccasionType.ChineseNewYear]: cny,
  [GiftCardOccasionType.Christmas]: christmas,
  [GiftCardOccasionType.Congrats]: congrats,
  [GiftCardOccasionType.Deepavali]: deepavali,
  [GiftCardOccasionType.EidMubarak]: eidMubarak,
  [GiftCardOccasionType.FathersDay]: fathersDay,
  [GiftCardOccasionType.GetWell]: getWell,
  [GiftCardOccasionType.Halloween]: halloween,
  [GiftCardOccasionType.MothersDay]: mothersDay,
  [GiftCardOccasionType.Newborn]: newBorn,
  [GiftCardOccasionType.NewYear]: newYear,
  [GiftCardOccasionType.ThankYou]: thankYou,
  [GiftCardOccasionType.Valentines]: valentines,
  [GiftCardOccasionType.Wedding]: wedding,
};

export const getGiftCardHero = (occasion: GiftCardOccasionType) =>
  HERO_BY_OCCASION[occasion] ?? giftForYou;

export const GIFT_CARD_STATUS: Record<
  GiftCardStatusEnum,
  { label: string; variant: NonNullable<TagProps["variant"]> }
> = {
  [GiftCardStatusEnum.PendingPayment]: { label: "Pending Payment", variant: "warning" },
  [GiftCardStatusEnum.Active]: { label: "Active", variant: "primary" },
  [GiftCardStatusEnum.Redeemed]: { label: "Redeemed", variant: "success" },
  [GiftCardStatusEnum.Expired]: { label: "Expired", variant: "neutral" },
  [GiftCardStatusEnum.Cancelled]: { label: "Cancelled", variant: "neutral" },
};
